export class Model_CRM_Branch
    {
        
  
         
        public BranchName : string;
        public ZoneName : string;
        public StateName: string;
        public CountryName  :string;
        public CityName :string;
        public ZoneId:  number;
        public CountryId: number;
        public StateId :number;  
        public CityId:number;
        public BranchId: number;
        public IsActive :boolean;

    


        
    }       